<template>
  <AdblockTopbar />
  <div class="bg-gray-100">
    <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
      <HeaderApp />
      <section class=" pt-2 pb-6 bg-gray-50 sm:py-1 lg:py-1">
        <div class="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
          <div class="max-w-2xl mx-auto text-center">
            <h2
              class="text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-5xl"
            >
              {{
                role == "monthly"
                  ? "Unlock all the best FB and Tiktok ad examples"
                  : "Get ahead of your competition"
              }}
            </h2>
            <p
              class="max-w-lg mx-auto mt-4 text-base leading-relaxed text-gray-600"
            >
              Don't waste your budget testing the wrong ads and boost your ROAS
              today!
            </p>
          </div>

          <!--  <div
            :class="
              role == 'monthly'
                ? 'flex min-h-full items-center justify-center py-0 px-4 sm:px-6 text-left'
                : role == 'free'
                ? 'lg:px-3 grid max-w-6xl grid-cols-1 gap-3 mx-auto mt-8 sm:mt-16 sm:grid-cols-3'
                : 'lg:px-8 grid max-w-4xl grid-cols-1 gap-6 mx-auto mt-8 sm:mt-16 sm:grid-cols-2'
            "
          >
            <div
              v-show="role == 'free'"
              class="relative bg-white rounded-md pb-3"
            >
              <div class="p-6 md:py-10 md:px-7">
                <div
                  class="flex text-left focus:text-indigo-500 inline-block px-4 py-2 pl-0"
                >
                  <h3
                    class="font-semibold text-sm text-gray-900 focus:text-indigo-500 bg-gray-200 rounded-full p-3 m-0"
                  >
                    <p>
                      Free
                    </p>
                  </h3>
                </div>
                <br />

                <div>
                  <p class="text-5xl font-semibold text-black">
                    $0
                  </p>
                </div>

                <p class="my-2 flex text-base text-gray-600 mb-4">
                  Per month
                </p>
                <br />

                <p class="mt-3 flex font-semibold text-gray-900 text-base my-6">
                  Ads from last year
                </p>

                <ul class="flex flex-col my-2">
                  <li class="inline-flex space-x-2 pb-3">
                    <svg
                      class="flex-shrink-0 w-5 h-5 text-green-500"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <span class="text-base font-medium text-gray-900">
                      30 FB Ad creatives
                    </span>
                  </li>
                </ul>
                <ul class="flex flex-col my-2">
                  <li class="inline-flex space-x-2 pb-3">
                    <svg
                      class="flex-shrink-0 w-5 h-5 text-green-500"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <span class="text-base font-medium text-gray-900">
                      30 viral Tiktok Ads
                    </span>
                  </li>
                </ul>

                <div class="flex items-center justify-center pay_btn">
                  <div class="absolute bottom-0 top-2 mt-6 mb-8 md:px-7">
                    <a
                      class="inline-flex items-center justify-center w-full px-4 py-5 mt-5 font-semibold text-white transition-all duration-200 bg-gray-400 rounded-md"
                      role="button"
                      disabled
                    >
                      Your current plan
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-for="plan in plans"
              :key="plan.id"
              class="relative bg-white rounded-md pb-3 box"
              :class="
                plan.period == 'year' ? 'border-4 border-indigo-500 ' : ''
              "
              
            >
              <div class="p-6 md:py-10 md:px-7 text-left hover:indigo-500">
                <div
                  class="flex hover:text-indigo-500 hover:indigo-500 focus:text-indigo-500 inline-block px-4 py-2 pl-0"
                >
                  <div
                    class="bg-gray-200 rounded-full p-3 m-0 hover:indigo-500"
                  >
                    <h3
                      class="text-sm font-semibold text-gray-900 hover:text-indigo-500 focus:text-indigo-500 "
                    >
                      <p>
                        {{ plan.name }}
                      </p>
                    </h3>
                  </div>
                </div>
                <br />

                <div class="flex" v-if="plan.use_discount">
                  <p class=" text-5xl font-bold text-gray line-through">
                    <span class="text-gray"> ${{ plan.price }} </span>
                  </p>
                  &nbsp;&nbsp;
                  <p class=" text-5xl font-bold text-black">
                    ${{ plan.discounted_price }}
                  </p>
                </div>
                <div v-else>
                  <p class="flex text-5xl font-bold text-black">
                    ${{ plan.price }}
                  </p>
                </div>

                <p class="mt-2 flex text-base text-gray-600 mb-6">
                  {{ plan.extras }}
                </p>

                <ul
                  v-for="(features, index) in plan.features"
                  :key="index"
                  class="flex flex-col my-2"
                >
                  <p
                    v-if="index == 0 && plan.period == 'month'"
                    class="mt-3 flex font-semibold text-gray-900 text-left text-base mb-6"
                  >
                    Ads from last months
                  </p>
                  <p
                    v-if="
                      (index == 0 && plan.period == 'year') ||
                        (index == 0 && plan.period == 'lifetime')
                    "
                    class="mt-3 flex font-semibold text-gray-900 text-left text-base mb-6"
                  >
                    Our Entire Ad Library
                  </p>
                  <li class="inline-flex items-center space-x-2 pb-3">
                    <svg
                      class="flex-shrink-0 w-5 h-5 text-green-500"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <span class="text-base font-medium text-gray-900">
                      {{ features }}
                    </span>
                  </li>
                  <p
                    v-if="index == 2"
                    class="flex mt-8 font-semibold text-gray-900 text-center text-base my-6"
                  >
                    Performance Resources
                  </p>

                  <p
                    v-if="
                      (index == 6 && plan.period == 'year') ||
                        (index == 6 && plan.period == 'lifetime')
                    "
                    class="flex font-semibold text-gray-900 text-center text-base my-6"
                  >
                    ACCESS FOREVER
                  </p>
                </ul>

                <div class="flex items-center justify-center my-5">
                  <div class="absolute bottom-0 top-2 mt-6 mb-8 md:px-7">
                    <a
                      v-if="plan.period == 'month'"
                      @click="buyMonthly"
                      class="inline-flex items-center justify-center w-full px-12 py-5 font-semibold text-white transition-all duration-200 bg-gray-900 rounded-md hover:bg-gray-600 focus:bg-gray-600"
                      role="button"
                    >
                      Unlock Monthly
                    </a>

                    <a
                      v-else
                      @click="buyAnnual"
                      class="flex items-center justify-center w-full px-12 py-5 font-semibold text-white transition-all duration-200 bg-gray-900 rounded-md hover:bg-gray-600 focus:bg-gray-600 btn"
                      role="button"
                      >Access Adbox</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
-->

          <div
            class="flex min-h-full items-center justify-center py-0 px-4 sm:px-6 text-left"
          >
            <div
              v-for="plan in plans"
              :key="plan.id"
              class="relative bg-white rounded-md pb-3 box"
              :class="
                plan.period == 'year' ? 'border-4 border-indigo-500 ' : ''
              "
            >
              <div class="p-6 md:py-10 md:px-7 text-left hover:indigo-500">
                <div
                  class="flex hover:text-indigo-500 hover:indigo-500 focus:text-indigo-500 inline-block px-4 py-2 pl-0"
                >
                  <div
                    class="bg-gray-200 rounded-full p-3 m-0 hover:indigo-500"
                  >
                    <h3
                      class="text-sm font-semibold text-gray-900 hover:text-indigo-500 focus:text-indigo-500 "
                    >
                      <p>
                        {{ plan.name }}
                      </p>
                    </h3>
                  </div>
                </div>
                <br />

                <div class="flex" v-if="plan.use_discount">
                  <p class=" text-5xl font-bold text-gray line-through">
                    <span class="text-gray"> ${{ plan.price }} </span>
                  </p>
                  &nbsp;&nbsp;
                  <p class=" text-5xl font-bold text-black">
                    ${{ plan.discounted_price }}
                  </p>
                </div>
                <div v-else>
                  <p class="flex text-5xl font-bold text-black">
                    ${{ plan.price }}
                  </p>
                </div>

                <p class="mt-2 flex text-base text-gray-600 mb-6">
                  {{ plan.extras }}
                </p>

                <ul
                  v-for="(features, index) in plan.features"
                  :key="index"
                  class="flex flex-col my-2"
                >
                  <p
                    v-if="index == 0 && plan.period == 'month'"
                    class="mt-3 flex font-semibold text-gray-900 text-left text-base mb-6"
                  >
                    Ads from last months
                  </p>
                  <p
                    v-if="
                      (index == 0 && plan.period == 'year') ||
                        (index == 0 && plan.period == 'lifetime')
                    "
                    class="mt-3 flex font-semibold text-gray-900 text-left text-base mb-6"
                  >
                    Our Entire Ad Library
                  </p>
                  <li class="inline-flex items-center space-x-2 pb-3">
                    <svg
                      class="flex-shrink-0 w-5 h-5 text-green-500"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <span class="text-base font-medium text-gray-900">
                      {{ features }}
                    </span>
                  </li>
                  <p
                    v-if="index == 2"
                    class="flex mt-8 font-semibold text-gray-900 text-center text-base my-6"
                  >
                    Performance Resources
                  </p>

                  <p
                    v-if="
                      (index == 6 && plan.period == 'year') ||
                        (index == 6 && plan.period == 'lifetime')
                    "
                    class="flex font-semibold text-gray-900 text-center text-base my-6"
                  >
                    ACCESS FOREVER
                  </p>
                </ul>

                <div class="flex items-center justify-center my-5">
                  <div class="absolute bottom-0 top-2 mt-6 mb-8 md:px-7">
                    <a
                      v-if="plan.period == 'month'"
                      @click="buyMonthly"
                      class="inline-flex items-center justify-center w-full px-12 py-5 font-semibold text-white transition-all duration-200 bg-gray-900 rounded-md hover:bg-gray-600 focus:bg-gray-600"
                      role="button"
                    >
                      Unlock Monthly
                    </a>

                    <a
                      v-else
                      @click="buyAnnual"
                      class="flex items-center justify-center w-full px-12 py-5 font-semibold text-white transition-all duration-200 bg-gray-900 rounded-md hover:bg-gray-600 focus:bg-gray-600 btn"
                      role="button"
                      >Access Adbox</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="py-8"></div>
    </div>
  </div>

  <Portal target="#confirm-upgrade">
    <ConfirmUpgrade v-model:isVisible="isConfirmVisible" />
  </Portal>
</template>

<script>
import { ref, computed, onBeforeMount, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import ConfirmUpgrade from "@/components/Modals/ConfirmUpgrade";
import AdblockTopbar from "@/components/AdblockTopbar";
import HeaderApp from "@/components/Header";
import { useRouter } from "vue-router";

export default {
  components: { ConfirmUpgrade, AdblockTopbar, HeaderApp },
  setup() {
    const store = useStore();
    const loading = ref(false);
    const router = useRouter();

    const role = computed(() => store.state.role);
    const status = computed(() => store.state.status);
    const plans = computed(() => store.state.plans);

    onBeforeMount(async () => {
      if (role.value == "lifetime" && status.value) {
        router.push("/");
      }
    });
    onMounted(async () => {
      store.dispatch("GET_SUBSCRIPTION_BY_USER");

      if (role.value == "lifetime" && status.value) {
        router.push("/");
      }
    });
    const subscription = computed(() => store.state.subscription);
    console.log("subs", subscription);
    onUnmounted(async () => {
      if (role.value == "lifetime" && status.value) {
        router.push("/");
      }
    });

    const buyMonthly = () => {
      const plan_id = 589466;
      store.dispatch("BUY_MEMBERSHIP", { plan_id });
    };

    const buyAnnual = () => {
      const plan_id = 636842;
      store.dispatch("BUY_MEMBERSHIP", { plan_id });
    };

    const buyLifetime = () => {
      if (role.value == "monthly") {
        console.log("monthly", subscription);
      }
      const plan_id = 824974;
      store.dispatch("BUY_MEMBERSHIP", { plan_id });
    };

    const isConfirmVisible = ref(false);

    const upgradeSubscription = () => {
      isConfirmVisible.value = true;
    };

    return {
      isConfirmVisible,
      upgradeSubscription,
      buyMonthly,
      buyAnnual,
      buyLifetime,
      role,
      loading,
      plans,
    };
  },
};
</script>

<style>
.btn {
  background-image: linear-gradient(90deg, #c026d3, #2563eb);
}
.btn:hover {
  background-image: linear-gradient(90deg, #ba55d3, #1f45fc);
}
.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 9px;
  margin: 7.2px 0;
}
.lds-ellipsis div {
  position: absolute;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #fff;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 6px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 6px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 24px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 42px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(18px, 0);
  }
}
</style>
